/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_type_proposal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggest a tool`)
};

const es_contact_type_proposal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerir una herramienta`)
};

const de_contact_type_proposal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool vorschlagen`)
};

const nl_contact_type_proposal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool voorstellen`)
};

const fr_contact_type_proposal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposer un outil`)
};

const it_contact_type_proposal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proponi uno strumento`)
};

const pt_br2_contact_type_proposal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerir uma ferramenta`)
};

const pt_contact_type_proposal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerir uma ferramenta`)
};

const ja_contact_type_proposal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツールを提案`)
};

const zh_contact_type_proposal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建议一个工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_type_proposal = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_type_proposal(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_type_proposal", locale)
	if (locale === "en") return en_contact_type_proposal(inputs)
	if (locale === "es") return es_contact_type_proposal(inputs)
	if (locale === "de") return de_contact_type_proposal(inputs)
	if (locale === "nl") return nl_contact_type_proposal(inputs)
	if (locale === "fr") return fr_contact_type_proposal(inputs)
	if (locale === "it") return it_contact_type_proposal(inputs)
	if (locale === "pt-BR") return pt_br2_contact_type_proposal(inputs)
	if (locale === "pt") return pt_contact_type_proposal(inputs)
	if (locale === "ja") return ja_contact_type_proposal(inputs)
	return zh_contact_type_proposal(inputs)
};